import { Component } from '@angular/core';
import { membersuiteCOGSEntryEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: COGS Entries') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuitecogsentry-form',
    templateUrl: './membersuitecogsentry.form.component.html'
})
export class membersuiteCOGSEntryFormComponent extends BaseFormComponent {
    public record!: membersuiteCOGSEntryEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

